/**
 * Throttle
 */
export function throttle(callback, delay) {
    let timer = null;

    return (...args) => {
        if (timer === null) {
            callback(args);
            timer = setTimeout(() => {
                timer = null;
            }, delay);
        }
    };
}

export function debounce(callback, delay) {
    let timer;

    return (...args) => {
        clearTimeout(timer);
        timer = setTimeout(() => {
            callback(args);
        }, delay);
    };
}
